import { render, staticRenderFns } from "./InvoiceStatusBadge.vue?vue&type=template&id=55b924fe&scoped=true&"
import script from "./InvoiceStatusBadge.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceStatusBadge.vue?vue&type=style&index=0&id=55b924fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b924fe",
  null
  
)

export default component.exports